import axios from "axios";
import  config  from "../../config";
const apiurl = config.ADMIN_BASE_URL;

const getToken = () => {
    return localStorage.getItem("cookies");
};



export const createCompetition = async (payload) => {
    const token = getToken();
    try {
        const response = await axios.post(
            `${apiurl}/competitions`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        return Promise.reject(error.response.data);
    }
};


export const getCompetitionById = async (competitionId) => {
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/competitions/${competitionId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const updateCompetition = async (competition_id, competitionData) => {
    const token = getToken();
    try {
        const response = await axios.post(
            `${apiurl}/competitions/${competition_id}`,
            competitionData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const fetchCompetitions = async (filters = {}, page = 1) => {
    const token = getToken();
    const queryParams = new URLSearchParams({ page, ...filters }).toString();
    try {
        const response = await axios.get(
            `${apiurl}/competitions?${queryParams}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const fetchCompetitionFilterList = async () => {
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/competitions/filter-list`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log("fetchCompetitionFilterList response:", response);
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const fetchCompetitionAttributes = async (module) => {
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/competitions/required-and-auto-join/${module}/attributes`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const fetchCompetitionParticipants = async (competitionId, params = {}) => {
    const token = getToken();
    const queryParams = new URLSearchParams(params).toString();
    try {
        const response = await axios.get(
            `${apiurl}/competitions/${competitionId}/participants?${queryParams}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const fetchCompetitionActivities = async (competitionId, params = {}) => {
    const token = getToken();
    const queryParams = new URLSearchParams(params).toString();
    try {
        const response = await axios.get(
            `${apiurl}/competitions/${competitionId}/activities?${queryParams}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const fetchCompetitionAnalytics = async (competitionId, filter) => {
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/competitions/${competitionId}/get-competition-analytics?no_of_days=${filter}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const competitionScheduleResultDate = async (competitionId, data) => {
    const token = getToken();
    try {
        const response = await axios.put(
            `${apiurl}/competitions/${competitionId}/schedule-result-declaration-date`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};



export const competitionParticipantsStatus = async (competitionId, data) => {
    console.log("data", data);
    const token = getToken();
    try {
        const response = await axios.put(
            `${apiurl}/competitions/${competitionId}/participants-status`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const competitionSchedule = async (competitionId, data) => {
    const token = getToken();
    try {
        const response = await axios.post(
            `${apiurl}/competitions/${competitionId}/schedule-notification`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getNotificationSchedule = async (competitionId) => {
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/competitions/${competitionId}/schedule-notification`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const deleteCompetitionNotificationSchedule = async (competitionId, deleteId) => {
    const token = getToken();
    try {
        const response = await axios.delete(
            `${apiurl}/competitions/${competitionId}/schedule-notification/${deleteId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }  catch (error) {
    return Promise.reject(error.response.data);
  }
};